import type { ReactNode } from 'react';
import Header from '../components/Header';

// /todo 是满屏三栏应用，不用 AppLayout：
// - AppLayout 的 container mx-auto p-4 会把三栏挤成一小块
// - AppLayout 顶部有全局 TimerBar，而 /todo 的计时条在中栏里，两个会重复
// - 满屏布局下 Footer 没有落点
// 保留 Header 是为了站内导航不断线。
export default function TodoLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-todo-list">
      <Header />
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
}
